import { DELETE_ALL_POINTS } from './actiontypes';

export function deleteAllPointsAction() {
  return {
    type: DELETE_ALL_POINTS,
  };
}
